module.exports = __webpack_public_path__ + "static/img/pic5.f196f2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd110/pic5.png
// module id = t12A
// module chunks = 1